import colors from "assets/theme-dark/base/colors";
import linearGradient from "assets/theme-dark/functions/linearGradient";
import { addOpacityToColor } from "./addOpacityToColor";

export const linearGradientStyle = {
};
